/**
 * Shortcut to link resources save on S3 'external-resources' repo
 * https://www.casa.it/external-resources/
 *
 * @param {String} [path] path of the resource
 * @returns {String} complete path to S3 'external-resources' repo
 */

export default function getExtPath(path) {
  // ensure we don't get a double slash in the returned path
  const completePath = `www.casa.it/external-resources/${path}`.replace(/\/\//g, '/');
  return `https://${completePath}`;
}
